/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import colors from '@sportninja/common/constants/appColors'
import React from 'react'

interface LoadingWrapperProps {
  loading: boolean
  children: React.ReactNode
  size?: 'small' | 'default' | 'large'
  fullHeight?: boolean
}

// Memoized loading indicator
const antIcon = (
  <LoadingOutlined style={{ fontSize: 24, color: colors.PRIMARY }} spin />
)

const LoadingWrapper: React.FC<LoadingWrapperProps> = ({
  loading,
  children,
  size = 'default',
  fullHeight = false,
}) => {
  if (!loading) {
    return <>{children}</>
  }

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        min-height: ${fullHeight ? '100%' : '200px'};
      `}
    >
      <Spin indicator={antIcon} size={size} />
    </div>
  )
}

export default LoadingWrapper
